import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import { Box, Dialog } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import GoogleIcon from '@mui/icons-material/Google';
import { requestoauthApi } from "../../services/authApi";



export default function GmailPopUp(props) {
  const { handleShowingFormsValues } = props


  const registerGmailClick = async () => {
    try {
      const response = await requestoauthApi({ action: "register" })
      window.open(response["data"]["url"], "mozillaWindow", "popup");
    } catch (error) {
      console.log("HavvveErrror")
    }
  }

  const loginGmailClick = async () => {
    try {
      const response = await requestoauthApi({ action: "login" })
      window.open(response["data"]["url"], "mozillaWindow", "popup");
    } catch (error) {
      console.log("HavvveErrror")
    }
  }
  return (
    <Box
      sx={{
        marginTop: 0.5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Avatar sx={{ m: 0.5, bgcolor: 'secondary.main' }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5" >
        Gmail
      </Typography>
      <Box noValidate sx={{ mt: 1 }}>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 1, mb: 1 }}
          onClick={registerGmailClick}
          endIcon={<GoogleIcon />}
        >
          ثبت نام
        </Button>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 1, mb: 1 }}
          onClick={loginGmailClick}
          endIcon={<GoogleIcon />}
        >
          ورود
        </Button>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 1, mb: 1 }}
          onClick={() => { handleShowingFormsValues("FormalLogin") }}
        >
          برگشت
        </Button>

      </Box>
    </Box>
  )
}